"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_TEXT = exports.BANNER_TEXT = void 0;
var BANNER_TEXT = {
  NEW: 'new',
  LIMITED: 'limited time offer',
  NERDWALLET: 'nerdwallet exclusive'
};
exports.BANNER_TEXT = BANNER_TEXT;
var SEARCH_TEXT = {
  NEW: 'new!',
  LIMITED: 'limited time offer',
  NERDWALLET: 'nerdwallet exclusive'
};
exports.SEARCH_TEXT = SEARCH_TEXT;